<div class="layout-topbar">
  <div class="topbar-start">
    <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
      <i class="pi pi-bars"></i>
    </button>
    <nav app-breadcrumb class="topbar-breadcrumb"></nav>
  </div>

  <app-busca-global class="topbar-busca"></app-busca-global>

  <div class="topbar-end">
    <div class="topbar-end__usuario" role="group" [attr.aria-label]="rotuloBlocoUsuario()">
      <span class="topbar-end__avatar" aria-hidden="true">
        @if (emailGravatar(); as email) {
        <img ngxGravatar [email]="email" [size]="40" [fallback]="'mm'" width="40" height="40" alt="" />
        } @else {
        <img ngSrc="assets/layout/images/avatar.png" width="40" height="40" alt="" />
        }
      </span>
      <div class="topbar-end__meta">
        <span class="topbar-end__login">{{ loginExibicao() }}</span>
        <span class="topbar-end__sigla">{{ siglaUnidade() }}</span>
      </div>
    </div>

    <div class="topbar-end__acoes" role="toolbar" aria-label="Ações da conta">
      <p-button
        type="button"
        styleClass="topbar-end__acao"
        [icon]="iconeTema()"
        [loading]="alterandoTema()"
        [text]="true"
        [pTooltip]="rotuloAlternarTema()"
        tooltipPosition="bottom"
        (onClick)="alternarTemaClaroEscuro()"
        [attr.aria-label]="rotuloAlternarTema()"
        [attr.aria-pressed]="modoEscuroAtivo() ? 'true' : 'false'"
        [attr.aria-busy]="alterandoTema() ? 'true' : null"
      />
      <p-button
        type="button"
        styleClass="topbar-end__acao topbar-end__acao--sair"
        icon="pi pi-sign-out"
        [text]="true"
        severity="danger"
        pTooltip="Encerrar sessão"
        tooltipPosition="bottom"
        (onClick)="encerrarSessao()"
        aria-label="Sair da sessão"
      />
    </div>
  </div>
</div>
